export default "__VITE_ASSET__BDAuSCMR__"